import Antd from 'ant-design-vue';
import * as bootstrap from 'bootstrap';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import configAxios from './config/axiosConfig';
import router, { addGuardRoutes } from './router';
import createCustomDirectives from './utils/directives';
import { getTokenSSO, setDataUser, setTokenSSO } from './utils/index';
import { checkLoginSSO, logoutUser, postMessageTokenIframe } from './utils/sso';

import { VueClipboard } from '@soerenmartius/vue3-clipboard';
import draggable from 'vuedraggable';
import mitt from 'mitt';
import VueDiff from 'vue-diff';
import Toast from 'vue-toastification';
import App from './App';
import filters from './utils/filters';

import VueTheMask from 'vue-the-mask';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// ligth theme
import 'ant-design-vue/dist/antd.css';
import 'primevue/resources/themes/lara-light-indigo/theme.css';
import 'primevue/resources/primevue.min.css';
// dark theme
//import 'ant-design-vue/dist/antd.dark.css';

import _ from 'lodash';
import './styles/global.css';
import './styles/responsive.css';

import 'vue-toastification/dist/index.css';

import 'vue-diff/dist/index.css';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Multiselect from 'primevue/multiselect';
import DataTable from 'primevue/datatable';
import AutoComplete from 'primevue/autocomplete';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
const emitter = mitt();

const app = createApp(App);
app.config.globalProperties.emitter = emitter;
app.config.globalProperties.$filters = filters;
app.config.productionTip = true;
app.use(CKEditor, {
  editor: ClassicEditor,
});
app.use(VueSweetalert2);
app.use(Antd);
app.use(VueClipboard);
app.use(VueDiff);

app.use(draggable);
app.use(Toast, {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
});
app.use(VueTheMask);
app.use(PrimeVue);
app.component('Button', Button);
app.component('Dialog', Dialog);
app.component('DataTable', DataTable);
app.component('Multiselect', Multiselect);
app.component('AutoComplete', AutoComplete);
app.mixin({
  methods: {
    filtroPadrao: function (input, option) {
      input = _.deburr(input.toLowerCase()); //removendo acentos e outros
      option = _.deburr(option.children()[0].children.toLowerCase()); //removendo acentos e outros
      return option.indexOf(input) >= 0;
    },
    delayed(callback, val, arg2) {
      if (val) {
        if (val.key && val.key != 'Backspace' && val.key != 'Delete' && val.key.length != 1) return;
        if (val.originalEvent && (val.originalEvent.type == 'blur' || val.originalEvent.type == 'keydown' || val.originalEvent.type == 'mousedown')) return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        callback(val, arg2);
      }, 700);
    },
    format_date(value, mask) {
      if (value) {
        return dayjs(value).format(mask || 'DD/MM/YYYY HH:mm');
      }
    },
  },
});
configAxios();
createCustomDirectives(app, bootstrap);

dayjs.locale('pt-br');

function removeTokenURL() {
  if (window.location.href.includes('access_token')) {
    const urlLocation = new URL(window.location.href);
    urlLocation.searchParams.delete('access_token');
    history.replaceState(history.state, null, urlLocation);
  }
}

async function start() {
  const url = new URL(window.location.href);

  let token = url.searchParams.get('access_token');

  postMessageTokenIframe(token);

  if (!token) {
    token = getTokenSSO();
  }

  removeTokenURL();
  setInterval(function () {
    removeTokenURL();
  }, 1000);

  const dataUser = await checkLoginSSO(token);

  setTokenSSO(token);
  setDataUser(dataUser);

  if (dataUser.isAuthenticated) {
    app.use(router);
    addGuardRoutes();
    app.mount('#app');
  } else await logoutUser();
}

start();
